// extracted by mini-css-extract-plugin
export default {"container":"signup__container__cZrZo","info":"signup__info__wQoDb","icon":"signup__icon__gOsav","title":"signup__title__xiVKF","blurb":"signup__blurb__GXG4X"};